module.exports = __webpack_public_path__ + "img/face.d90ce3d8.png";